import { render, staticRenderFns } from "./Pcr.vue?vue&type=template&id=28f6c79a&scoped=true&"
import script from "./Pcr.vue?vue&type=script&lang=js&"
export * from "./Pcr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6c79a",
  null
  
)

export default component.exports